'use es6';

import http from 'hub-http/clients/apiClient';
export const getCountry = () => http.get('monetization/v2/country');